import type { DealOptionField } from './types';

export const DEAL_OPTION_FIELDS: Array<DealOptionField> = [];
